import React from 'react';

import Button from 'components/form/Button.component';
import { useTranslation } from 'providers/GILT.provider';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';
import ServiceItem from 'clientCommunications/components/Clients/common/ServiceItem';

const AllServiceDropDown = ({ totalServicesNumber, selectedServices, isServiceOpen, services, filterService, closeServiceDropDown, onSelectServiceItem, onSelectAllService }) => {
  const { t } = useTranslation();

  const onDone = () => {
    filterService(selectedServices);
    closeServiceDropDown();
  };

  const allServiceSelected = totalServicesNumber === selectedServices.length;
  // TODO: update css classes

  return (
    <div data-bem="AllServiceDropDown" className={`drop-down dd-service ${isServiceOpen ? '' : 'hidden'} `}>
      <div className="main">
        <span className="span-header">{t('allClients.allServicesDropdown.title')}</span>
        <ul>
          {services.map((category) => (
            <ServiceItem key={category.id} service={category} selectedServices={selectedServices} onSelectService={onSelectServiceItem} />
          ))}
        </ul>
      </div>
      <DropdownMenuFooter>
        <Button variant="slim" onClick={() => onSelectAllService(allServiceSelected)}>
          {!allServiceSelected ? t('common.buttons.selectAllUpp') : t('common.buttons.clearAllUpp')}
        </Button>
        <Button variant="slim" onClick={onDone}>
          {t('common.buttons.doneUpp')}
        </Button>
      </DropdownMenuFooter>
    </div>
  );
};

export default AllServiceDropDown;
